var map = {
	"./de.json": [
		1224,
		1
	],
	"./de_CH.json": [
		1262,
		53
	],
	"./en.json": [
		661
	],
	"./en_CA.json": [
		1263,
		0
	],
	"./en_CH.json": [
		1264,
		0
	],
	"./en_GB.json": [
		1265,
		0
	],
	"./fr.json": [
		1266,
		54
	],
	"./it.json": [
		1267,
		55
	],
	"./it_CH.json": [
		1268,
		0
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 742;
module.exports = webpackAsyncContext;